import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { BannerDetails } from '../BannerDetails/BannerDetails';
import { LanguageType } from '@lifeserver/shared';

import { useCreateBanner } from '../../hooks/banners';

import { RouteTo } from '../../routes';

import { CreateOrUpdateBanner } from '../../types/bannerTypes';

import { createEmptyBanner } from '../emptyBanner';

type BannerProps = { language: LanguageType };

export const BannerCreatePage = (props: BannerProps) => {
    const {
        bannerId,
        isLoading: isCreateBannerLoading,
        createBanner,
    } = useCreateBanner();
    const navigate = useNavigate();

    useEffect(() => {
        if (bannerId) {
            navigate(RouteTo.BannerEdit(bannerId.toString()));
        }
    }, [bannerId]);

    async function onSave(banner: CreateOrUpdateBanner) {
        try {
            await createBanner(banner);
            return true;
        } catch {
            return false;
        }
    }

    return (
        <BannerDetails
            language={props.language}
            isNew={true}
            onSave={onSave}
            initialBanner={createEmptyBanner()}
            isSaving={isCreateBannerLoading}
        />
    );
};
